<template>
    <div>
      <div class="modal hide fade" id="modalTaxMonitoringPurchasingModal" tabindex="-1" role="dialog" aria-labelledby="modalTaxMonitoringPurchasingModal" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered" role="document">
              <div class="modal-content">
                  <div class="modal-header red darken-3 text-left text-white">
                      <h4 class="modal-title w-100 font-weight-bold">Tax Saldo</h4>
                      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                      </button>
                  </div>
                  <div class="modal-body">
                      <form>
                        <div class="form-group">
                          <label for="faktur_date" class="col-form-label">Faktur Date</label>
                          <datetime v-model="taxValue.faktur_date" format="dd/MM/yyyy" class="form-control" value-zone="Asia/Jakarta" zone="Asia/Jakarta"></datetime>
                        </div>
                        <div class="form-group">
                          <label for="faktur_no" class="col-form-label">Faktur No.</label>
                          <input v-model="taxValue.faktur_no" type="text" class="form-control"/>
                        </div>
                        <div class="form-group">
                          <label for="faktur_date" class="col-form-label">Faktur Process Date</label>
                          <datetime v-model="taxValue.faktur_process_date" format="dd/MM/yyyy" class="form-control" value-zone="Asia/Jakarta" zone="Asia/Jakarta"></datetime>
                        </div>
                      </form>
                  </div>
                  <div class="modal-footer">
                  <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                  <button type="button" class="btn btn-primary" data-dismiss="modal" @click="save">Save</button>
                  </div>
              </div>
          </div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'TaxMonitoringModal',
  props: ['taxValue'],
  data () {
    return {
      data: {
        faktur_date: null,
        faktur_no: null,
        faktur_process_date: null
      }
    }
  },
  methods: {
    async save () {
      this.$emit('processFaktur', this.taxValue)
    }
  }
}
</script>
